module.exports = __webpack_public_path__ + "static/media/flexiti.62abef5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-methods/flexiti.jpg
// module id = 1080
// module chunks = 0